module.exports = __webpack_public_path__ + "img/MK_logo.e5e15cbc.svg";